import './jqueryLib'
import 'jquery-parallax.js'

(function ($) {
    $(function () {
        $('.parallax-window').parallax();
    })
})(jQuery)